import { useState, useEffect } from 'react';
import Slider from '../components/Slider/Slider';
import LoadingSpinner from '../components/shared/LoadingSpinner';
import FixedSidebar from '../components/Sidebar/FixedSidebar';
import Services from '../components/Services';
import Skills from '../components/Skills/Skills';
import Timeline from '../components/Timeline/Timeline';
import Testimonials from '../components/Testimonials/Testimonials';
import HeroSection from '../components/HeroSection/HeroSection';
import About from '../components/About/About';
import Nav from '../components/Navbar/Nav';
import Footer from '../components/Footer';

export default function HomePage() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const fetchUser = async () => {
      // 'data.json' file is located in "public/" fetching data locally
      try {
        const response = await fetch('/data.json');
        const data = await response.json();
        setUser(data.user);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchUser();
  }, []);
  return (
    <>
      {user ? (
        <div>
          <Nav name={user.about.name} />
          <FixedSidebar socialHandles={user.social_handles} />
          <HeroSection about={user.about} />
          <Slider projects={user.projects} />
          <Services services={user.services} />
          <Timeline timeline={user.timeline} />
          <Skills skills={user.skills} />
          <Testimonials testimonials={user.testimonials} />
          <About about={user.about} />
          <Footer href={user.about.contactEmail} />
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
}
